import React from "react";
import { DialogContentText, Typography, DialogTitle, IconButton, Stack } from "@mui/material";
import ModalLayout from "./Layout";
import ModalLayoutHeader from "./Layout/Header";
import ModalLayoutContent from "./Layout/Content";
import ModalLayoutFooter from "./Layout/Footer";
import ModalLayoutBtn from "./Layout/Btn";
import { GitBranch, X } from "react-feather";

/**
 *
 * @param {{
 *  isShown: boolean;
 *  onHide: () => void;
 *  onAction: () => void;
 *  activeBranch: string;
 * }} data
 */
const SwitchBranchModal = ({ isShown, onHide, onAction, activeBranch }) => {
  return (
    <ModalLayout 
      isShown={isShown} 
      onHide={onHide}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "12px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
          overflow: "hidden",
          background: "linear-gradient(to bottom, #ffffff, #f8f9fa)",
          border: "1px solid rgba(0,0,0,0.08)",
          transition: "all 0.3s ease-in-out"
        }
      }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        position={"relative"}
        padding={"16px 24px"}
        borderBottom={"1px solid rgba(0,0,0,0.05)"}
        sx={{ background: "rgba(235,245,255,0.6)" }}
      >
        <DialogTitle
          padding={"0 !important"}
          sx={{
            color: "#3f51b5",
            fontWeight: 800,
            fontSize: "11px",
            display: "flex",
            alignItems: "center",
            "::before": {
              content: '""',
              display: "inline-block",
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "#3f51b5",
              marginRight: "10px",
              animation: "pulse 1.5s infinite",
              "@keyframes pulse": {
                "0%": { boxShadow: "0 0 0 0 rgba(63, 81, 181, 0.7)" },
                "70%": { boxShadow: "0 0 0 10px rgba(63, 81, 181, 0)" },
                "100%": { boxShadow: "0 0 0 0 rgba(63, 81, 181, 0)" }
              }
            }
          }}
        >
          <GitBranch size={14} style={{ marginRight: "6px" }} />
          You are switching branch.
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onHide}
          sx={{
            position: "absolute",
            right: 16,
            top: 10,
            color: "#495057",
            "&:hover": {
              background: "rgba(0,0,0,0.05)",
              transform: "rotate(90deg)",
              transition: "transform 0.3s ease"
            }
          }}
        >
          <X size={16} />
        </IconButton>
      </Stack>
      <ModalLayoutContent sx={{ padding: "24px 28px" }}>
        <DialogContentText
          textAlign={"center"}
          color="#4a4a4a"
          sx={{ fontSize: "11px", lineHeight: 1.6 }}
        >
          Switching branch will close your open tabs - except for untitled ones - from{" "}
          <Typography
            component={"span"}
            fontWeight={700}
            sx={{ 
              fontSize: "11px",
              color: "#5c6bc0",
              background: "rgba(235,238,252,0.8)",
              padding: "2px 6px",
              borderRadius: "4px",
              border: "1px solid rgba(92,107,192,0.2)"
            }}
          >
            {activeBranch}
          </Typography>
          <br />
          <Typography
            component={"span"}
            fontWeight={700}
            sx={{ 
              fontSize: "11px",
              color: "#2e7d32",
              background: "rgba(232,245,233,0.8)",
              padding: "2px 6px",
              borderRadius: "4px",
              border: "1px solid rgba(46,125,50,0.2)",
              margin: "8px 0",
              display: "inline-block"
            }}
          >
            Your work is saved
          </Typography>&nbsp;
          and you can always switch back to{" "}
          <Typography
            component={"span"}
            fontWeight={700}
            sx={{ 
              fontSize: "11px",
              color: "#5c6bc0",
              background: "rgba(235,238,252,0.8)",
              padding: "2px 6px",
              borderRadius: "4px",
              border: "1px solid rgba(92,107,192,0.2)"
            }}
          >
            {activeBranch}
          </Typography>{" "}
          to retrieve queries.
        </DialogContentText>
      </ModalLayoutContent>
      <ModalLayoutFooter sx={{ padding: "16px 24px" }}>
        <ModalLayoutBtn 
          color="primary" 
          onClick={onAction}
          variant="contained"
          sx={{
            fontSize: "11px",
            borderRadius: "8px",
            fontWeight: 600,
            textTransform: "none",
            padding: "8px 24px",
            transition: "all 0.2s",
            background: "linear-gradient(45deg, #3f51b5, #5c6bc0)",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0 4px 12px rgba(63,81,181,0.3)"
            }
          }}
        >
          Continue
        </ModalLayoutBtn>
      </ModalLayoutFooter>
    </ModalLayout>
  );
};

export default SwitchBranchModal;
